import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { extractApiError } from "../lib/errors";
import { toast } from "sonner";

const LOGO = "/ashra-logo.png";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error("Password must be at least 8 characters.");
    if (pw !== pw2) return toast.error("Passwords don't match.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password updated. Please sign in.");
      navigate("/login");
    } catch (err) {
      toast.error(extractApiError(err, "Could not reset password"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen bg-white text-zinc-900 overflow-hidden flex items-center justify-center px-4">
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute -top-32 -left-32 h-[28rem] w-[28rem] rounded-full blur-3xl opacity-30 ashra-gradient-bg" />
        <div className="absolute -bottom-32 -right-32 h-[28rem] w-[28rem] rounded-full blur-3xl opacity-20 ashra-gradient-bg" />
      </div>
      <div className="relative w-full max-w-md bg-white border border-zinc-200 rounded-3xl shadow-2xl shadow-violet-500/5 p-8">
        <Link to="/" className="flex items-center gap-2 mb-6" data-testid="reset-logo">
          <img src={LOGO} alt="Ashra AI" className="h-10 w-auto" />
        </Link>
        <h1 className="font-display text-2xl font-extrabold tracking-tight">Set a new password</h1>
        <p className="mt-1 text-sm text-zinc-600">Choose something secure — at least 8 characters.</p>

        {!token ? (
          <div className="mt-6 rounded-2xl bg-rose-50 border border-rose-200 text-rose-800 px-4 py-3 text-sm" data-testid="reset-no-token">
            Reset link is missing or invalid. <Link to="/forgot-password" className="font-semibold underline">Request a new one</Link>.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-3">
            <input
              type="password" required value={pw} onChange={(e) => setPw(e.target.value)}
              placeholder="New password (min 8 chars)" autoFocus
              className="w-full rounded-xl border border-zinc-200 bg-white px-4 py-3 text-sm outline-none focus:border-violet-500"
              data-testid="reset-pw"
            />
            <input
              type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)}
              placeholder="Confirm new password"
              className="w-full rounded-xl border border-zinc-200 bg-white px-4 py-3 text-sm outline-none focus:border-violet-500"
              data-testid="reset-pw2"
            />
            <button type="submit" disabled={loading} data-testid="reset-submit"
              className="w-full rounded-xl ashra-gradient-bg text-white font-semibold py-3 text-sm hover:opacity-95 transition disabled:opacity-60">
              {loading ? "Saving…" : "Update password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
